import React from 'react';
import { useNavigate } from 'react-router-dom';
import Simulador from '../Simulador/Simulador';
import './Hero.css';

const Hero = () => {
  const navigate = useNavigate();

  return (
    <section id="inicio" className="hero">
      <div className="hero__left">
        <div className="hero__badge">
          <i className="fa-solid fa-bolt"></i> Evaluación rápida
        </div>
        <h1 className="hero__title">
          El dinero que necesitas,{' '}
          <span className="hero__highlight">hoy mismo.</span>
        </h1>
        <p className="hero__desc">
          Créditos diseñados para peruanos emprendedores. Sin trámites eternos,
          con la confianza de una entidad registrada en la SBS.
        </p>
        <div className="hero__chips">
          <span className="hero__chip">Con DNI</span>
          <span className="hero__chip">Evaluación segura</span>
          <span className="hero__chip">100% Transparente</span>
        </div>
        <div className="hero__buttons">
          <button className="btn-primary" onClick={() => navigate('/register')}>
            Solicitar Préstamo
          </button>
        </div>
      </div>

      <div className="hero__simulator">
        <Simulador />
      </div>
    </section>
  );
};

export default Hero;
